import { GET } from "@/lib/methods";
import { useQuery } from "@tanstack/react-query";

type MealIngredientsReturnType = {
  ingredients: string[];
};

const useMealIngredients = ({
  dietId,
  ingredientsId,
}: {
  dietId: string;
  ingredientsId: number | undefined;
}) => {
  return useQuery({
    queryKey: ["preview-ingredients", dietId, ingredientsId],
    queryFn: () =>
      GET<MealIngredientsReturnType>({
        url: `${process.env.NEXT_PUBLIC_FOOAPP_URL}/menu-preview/${dietId}/${ingredientsId?.toString()}/ingredients`,
      }),
    enabled: !!ingredientsId,
    retry: 3,
  });
};

export { useMealIngredients };
